/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominate Your`)
};

const es_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domina Tu`)
};

const de_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominiere deine`)
};

const nl_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domineer Jouw`)
};

const fr_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominez Votre`)
};

const it_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domina La Tua`)
};

const pt_br2_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domine Sua`)
};

const pt_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domine A Sua`)
};

const ja_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファンタジーリーグを`)
};

const zh_f1_home_hero_line1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`称霸您的`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_hero_line1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_hero_line1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_hero_line1", locale)
	if (locale === "en") return en_f1_home_hero_line1(inputs)
	if (locale === "es") return es_f1_home_hero_line1(inputs)
	if (locale === "de") return de_f1_home_hero_line1(inputs)
	if (locale === "nl") return nl_f1_home_hero_line1(inputs)
	if (locale === "fr") return fr_f1_home_hero_line1(inputs)
	if (locale === "it") return it_f1_home_hero_line1(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_hero_line1(inputs)
	if (locale === "pt") return pt_f1_home_hero_line1(inputs)
	if (locale === "ja") return ja_f1_home_hero_line1(inputs)
	return zh_f1_home_hero_line1(inputs)
};